/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import { format } from 'date-fns'
// import moment from 'moment'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Button from 'components/Button'
import Dialog from 'components/Dialog'
import constants from 'constants'
import { IconCheck, IconCross } from 'icons'

const styles = Object.assign(
  {},
  require('../PartnerPlanList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class PartnerPlanRatingVisibilityList extends Component {
  static propTypes = {
    header: PropTypes.string,
    partnerPlanPlanRatingVisibility: PropTypes.object,
    ratingVisibilityItems: PropTypes.instanceOf(Array),
    updatePartnerPlanRatingVisibility: PropTypes.func.isRequired,
  }
  static defaultProps = {
    partnerPlanPlanRatingVisibility: null,
    ratingVisibilityItems: {},
    header: '',
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDialogOpen: false,
      submit: false,
      itemSelected: '',
    }
  }
  _openConfirmDialog = (item) => {
    this.setState({ confirmDialogOpen: true })
    this.setState({ itemSelected: item })
  }

  _closeConfirmDialog = () => {
    this.setState({ confirmDialogOpen: false })
  }

  _saveConfirmDialog = () => {
    this.setState({
      confirmDialogOpen: false,
      submit: true,
    })
    this.props.updatePartnerPlanRatingVisibility(this.state.itemSelected)
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.description, headerStyles)}>
          Business unit
        </th>
        <th className={(styles.columns.created, headerStyles)}>Stage</th>
        <th className={(styles.columns.created, headerStyles)}>Show final rating</th>
        <th className={(styles.columns.created, headerStyles)}>Last modified</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.ratingVisibilityItems.length ? (
      this.props.ratingVisibilityItems.map((bu, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.base} key={`${bu.id}-${i}`}>
          <td className={styles.lockedaccount}>
            {bu.business_unit}
          </td>
          <td>{bu.stage}</td>
          <td>{bu.enabled ? <IconCheck className={styles.icon} /> : <IconCross className={styles.crossIcon} />}</td>
          <td>{bu.time_stamp ? format(new Date(bu.time_stamp), constants.DATE_FORMAT.PARTNER_PLAN_LIST) : ''}</td>
          <td>
            <Button
              className={classnames(bu.enabled ? styles.buttonGrayBorder : styles.buttonGreenBorder)}
              onClick={() => {
                this._openConfirmDialog(bu)
              }}
              type="flat"
            >
              {bu.enabled ? 'HIDE FINAL RATING' : 'RELEASE FINAL RATING'}
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noAccountsAndLoans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    const { confirmDialogOpen, itemSelected } = this.state
    const isEnabled = itemSelected.enabled

    const dialogTitle = isEnabled ?
      `Hide ${itemSelected.business_unit} ${itemSelected.year} ${itemSelected.stage} final ratings to Partner?` :
      `Release ${itemSelected.business_unit} ${itemSelected.year} ${itemSelected.stage} final ratings to Partner?`
    const dialogMessage = isEnabled
      ? `Are you sure you want to hide ${itemSelected.business_unit} ${itemSelected.year} ${itemSelected.stage} final ratings?\n\nThis will make the final rating not visible to partners. You can release the ratings at any time.`
      : `Do you want to release ${itemSelected.business_unit} ${itemSelected.year} ${itemSelected.stage} final ratings?\n\nOnce release, partners will see their final ratings immediately.`

    const dialogProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDialog },
        { label: 'CONFIRM', onClick: this._saveConfirmDialog },
      ],
      title: dialogTitle,
      active: confirmDialogOpen,
      onClose: this._closeConfirmDialog,
      children: (
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {dialogMessage}
        </div>
      ),
    }

    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
        <Dialog {...dialogProps} />
      </div>
    )
  }
}

export default PartnerPlanRatingVisibilityList



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/PartnerPlan/PartnerPlanRatingVisibilityList.js